import { DECLARATION_TEMPLATES } from 'services/declaration_templates';

export interface TempletesListOption {
  value: string;
  label: string;
  description: string;
}

// Derivada da fonte única dos modelos (declaration_templates).
export const TempletesListOptions: TempletesListOption[] = DECLARATION_TEMPLATES.map(
  (template) => ({ value: template.id, label: template.label, description: template.titulo }),
);
